<template>
  <div>
    <naj-box :title="local.caseRelatedRequest.relatedPartyInfo">
      <div>
        <v-col cols="6">
          <naj-input
            :type-id="formFieldType.selectbox"
            :value.sync="requestCasePartyId"
            :label="local.caseRelatedRequest.relatedPartyInfo"
            :items="basicCasePartiesInfo"
            item-value="casePartyId"
            item-text="name"
            validates="required"
            :disabled="true"
          ></naj-input>
          <div v-if="isViewMode && isLoggedInUserCasePartyAgentOrRepresentative">
            <naj-input
              v-if="isReplyMode"
              :type-id="formFieldType.multipleSelectBox"
              :label="local.caseRelatedRequest.waiverOfAppealRequest.onBehalfOf"
              :value.sync="formModel.casePartyIds"
              :items="waiverOfAppealRespondents"
              item-value="casePartyId"
              item-text="name"
              validates="required"
              @change="setWaiverOfAppealRecord"
            ></naj-input>
            <naj-input
              v-if="!isReplyMode && representatives.length > 0 && !checkRequestCaseParty"
              :type-id="formFieldType.selectbox"
              :label="local.caseRelatedRequest.waiverOfAppealRequest.onBehalfOf"
              :value.sync="representativeCasePartyId"
              :items="representatives"
              item-value="casePartyId"
              item-text="name"
              validates="required"
              @change="changeRepresentativesEvent"
            ></naj-input>
          </div>
          <naj-input
            v-if="isNewMode && isLoggedInUserCasePartyAgentOrRepresentative"
            :type-id="formFieldType.selectbox"
            :label="local.caseRelatedRequest.waiverOfAppealRequest.onBehalfOf"
            :value.sync="formModel.applicantCasePartyId"
            :items="waiverOfAppealRespondents"
            item-value="casePartyId"
            item-text="name"
            validates="required"
            @change="setWaiverOfAppealRecord"
          ></naj-input>
        </v-col>
      </div>
    </naj-box>
    <naj-box :title="local.caseRelatedRequest.waiverOfAppealRequest.JudgmentInfo">
      <v-row>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.selectbox"
            :value.sync="formModel.judgementCode"
            :label="local.caseRelatedRequest.waiverOfAppealRequest.judgementCode"
            :items="judgments"
            item-value="judgementCode"
            item-text="judgementCode"
            :validates="`required`"
            :disabled="isViewMode || isEditMode"
            @change="setSelectedJudgment"
          ></naj-input>
        </v-col>

        <v-col
          cols="1"
          class="judgement-deed"
        >
          <naj-button
            :disabled="!selectedJudgment.objectKey"
            @click="getJudgementDeed"
          >
            {{ local.caseRelatedRequest.waiverOfAppealRequest.displayJudgement }}
          </naj-button>
        </v-col>
      </v-row>
    </naj-box>
    <case-judgement-modal
      :selected-judgement="selectedJudgment"
      :modal-visibility="showCaseJudgementModal"
      @modalClose="closeCaseJudgementModal"
    ></case-judgement-modal>

    <naj-box
      v-if="showReply"
      :title="local.requestReply.requestReplyButtonText"
    >
      <v-row v-if="formModel.approvalStatus === 1">
        <v-col>
          <naj-alert type="alert">
            <template slot="content">
              {{ local.caseRelatedRequest.waiverOfAppealRequest.AcceptRequestMessage }}
            </template>
          </naj-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.radioButton"
            :value.sync="formModel.approvalStatus"
            :items="waiverOfAppealRequestResponse"
            item-text="name"
            item-value="id"
            class="radio-button-option-v1"
            validates="required"
            :disabled="!disabledReply"
            @change="waiverOfAppealResponseChanged"
          >
          </naj-input>
        </v-col>
      </v-row>
    </naj-box>
    <v-row v-if="disabledReply">
      <v-col
        cols="6"
        class="text-right"
      >
        <naj-button
          outlined
          @click="$router.back()"
        >
          {{ local.common.returnToRequests }}
        </naj-button>
      </v-col>
      <v-col
        cols="6"
        class="text-left"
      >
        <naj-button
          :disabled="!(isVerifiedApprovalStatusSelected && isVerifiedCasePartiesSelected)"
          @click="openConfirmationModel"
        >
          {{ local.common.saveAndSend }}
        </naj-button>
      </v-col>
    </v-row>
    <naj-confirmation
      :show-modal="confirmSubmitDialog"
      :max-width="472"
      :title="local.common.confirmRequestSubmission"
      :message="local.caseRelatedRequest.waiverOfAppealRequest.replyConfirmationMessage"
      :ok-btn-label="local.common.yes"
      :close-btn-label="local.common.close"
      @ok="saveCasePartyResponse"
      @cancel="confirmSubmitDialog = false"
    >
    </naj-confirmation>
  </div>
</template>

<script>
import { mode, socialIdentityTypeEnum, countriesEnum, casePartyRoleEnum } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
const { mapActions } = createNamespacedHelpers('CasesModule');
import CaseJudgementModal from '../../../../cases/case-judgement-modal';

export default {
  name: 'WaiverOfAppealRequest',
  inject: ['$validator'],
  components: { CaseJudgementModal },
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      judgments: [],
      showCaseJudgementModal: false,
      basicCasePartiesInfo: [],
      isLoggedInUserCasePartyAgentOrRepresentative: false,
      WaiverOfAppealRespondentCasePartyId: null,
      waiverOfAppealRespondents: [],
      WaiverOfAppeal: null,
      showAlertModal: false,
      selectedJudgment: {},
      confirmSubmitDialog: false,
      requestCasePartyId: null,
      userInfoCasePartyId: null,
      representatives: [],
      representativeCasePartyId: null,
    };
  },
  computed: {
    ...mapLUTState(['waiverOfAppealRequestResponse',
    ]),
    ...mapGlobalState(['userInfo']),
    isReplyMode() {
      return this.$route.meta.replyToRequest;
    },
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
    representativeCasePartiesSelectboxDisabled() {
      return this.isViewMode || (this.formModel.representativeCasePartyId && this.isLoggedInUserExistsAsCaseParty);
    },
    isVerifiedApprovalStatusSelected() {
      if (this.formModel.approvalStatus != undefined && this.formModel.casePartyId != undefined) {
        return true;
      }

      return false;
    },
    isVerifiedCasePartiesSelected() {
      if (this.isLoggedInUserCasePartyAgentOrRepresentative && (this.formModel.casePartyIds == null || this.formModel.casePartyIds.length === 0)) {
        return false;
      }
      return true;
    },
    disabledReply() {
      return this.isReplyMode && this.isViewMode && this.formModel.canReply;
    },
    checkRequestCaseParty() {
      return this.requestCasePartyId === this.userInfoCasePartyId && !this.isLoggedInUserCasePartyAgentOrRepresentative;
    },
    showReply() {
      return !this.isNewMode && !this.checkRequestCaseParty && (this.isReplyMode || this.representativeCasePartyId != null || !this.isLoggedInUserCasePartyAgentOrRepresentative);
    },
  },
  mounted() {
    this.loading = true;
    const params = {
      isPega: this.formModel.isPega,
      objectKey: this.formModel.case.objectKey,
    };

    Promise.all([
      this.getIcmsUserRoleFromCasePartyRolesInCase(this.formModel.case.objectKey),
      this.getCaseBasicParties(params),
      this.getCaseJudgments(params),
      this.isViewMode ?
        this.getWaiverOfAppealRespondents({
          caseObjectKey: this.formModel.case.objectKey,
          requestObjectKey: this.formModel.objectKey,
        })
        : this.getCaseRequestApplicants(params),
      !this.isReplyMode && this.viewMode ? this.getRepresentativesWaiverOfAppeal({
        caseObjectKey: this.formModel.case.objectKey,
        requestObjectKey: this.formModel.objectKey,
      }) : null,
    ]).then((res) => {
      this.userCasePartyRoleInCase = res[0].data;
      this.basicCasePartiesInfo = res[1].data;
      this.judgments = res[2].data;

      this.setSelectedJudgment();
      if (this.userCasePartyRoleInCase.roleInCaseId == casePartyRoleEnum.agent ||
        this.userCasePartyRoleInCase.roleInCaseId == casePartyRoleEnum.lawyer ||
        this.userCasePartyRoleInCase.roleInCaseId == casePartyRoleEnum.representative) {
        this.isLoggedInUserCasePartyAgentOrRepresentative = true;
      }
      this.waiverOfAppealRespondents = this.isViewMode ? res[3].data : res[3].data.requestApplicants;
      this.representatives = !this.isReplyMode && this.viewMode ? res[4].data : [];
      this.setRelatedPartyAsRequestApplicant();
      this.setWaiverOfAppealRecord();
      this.getCasePartyIdByUserInfo();
    })
      .finally(() => (this.loading = false));

    if (this.formModel) {
      if (this.formModel.judgementCode) {
        this.setSelectedJudgment();
      }
      this.readCurrentUserInfo();
    }

  },
  methods: {
    ...mapActions(['getCaseJudgments'
      , 'getCaseRequestApplicants'
      , 'getIcmsUserRoleFromCasePartyRolesInCase'
      , 'getCaseBasicParties'
      , 'getWaiverOfAppealRespondents'
      , 'sendWaiverOfAppealRequestPartyReply'
      , 'getRepresentativesWaiverOfAppeal']),
    setSelectedJudgment() {
      this.formModel.judgementCode && this.$set(this, 'selectedJudgment', (this.judgments || []).find(a => a.judgementCode == this.formModel.judgementCode) || {});
    },
    setWaiverOfAppealRecord() {
      this.$set(this.formModel, 'casePartyIds', this.formModel.casePartyIds);
      this.$set(this.formModel, 'casePartyId', this.userCasePartyRoleInCase.casePartyId);
      this.$set(this.formModel, 'caseObjectKey', this.formModel.case.objectKey);
    },
    waiverOfAppealResponseChanged() {
      this.$set(this.formModel, 'isApproved', this.formModel.approvalStatus);
      this.$set(this.formModel, 'requestObjectKey', this.formModel.objectKey);
    },
    getJudgementDeed() {
      if (this.selectedJudgment.isSecretJudgements) {
        this.showAlertModal = true;
      } else {
        this.showCaseJudgementModal = true;
      }
    },
    closeCaseJudgementModal() {
      this.showCaseJudgementModal = false;
    },
    setRelatedPartyAsRequestApplicant() {
      const selectedParty = this.basicCasePartiesInfo.find(cp => cp.partyId == this.userCasePartyRoleInCase.partyId);
      if (this.isNewMode) {
        this.requestCasePartyId = selectedParty.casePartyId;
      } else {
        const requestPerson = this.basicCasePartiesInfo.find(cp => cp.casePartyId == this.formModel.applicantCasePartyId);
        this.requestCasePartyId = requestPerson.casePartyId;
      }
      if (selectedParty) {
        this.isLoggedInUserExistsAsCaseParty = true;

        if (this.isLoggedInUserCasePartyAgentOrRepresentative) {
          this.$set(this.formModel, 'representativeCasePartyId', this.formModel.representativeCasePartyId || selectedParty.casePartyId);
        }
        else {
          this.$set(this.formModel, 'applicantCasePartyId', this.formModel.applicantCasePartyId || selectedParty.casePartyId);
        }
      }
    },
    getCasePartyIdByUserInfo() {
      const caseParty = this.basicCasePartiesInfo.find(cp => cp.identityNumber === this.userInfo.socialId);
      this.userInfoCasePartyId = caseParty.casePartyId;
    },
    openConfirmationModel() {
      this.confirmSubmitDialog = true;
    },
    saveCasePartyResponse() {
      this.setWaiverOfAppealRecord();
      this.sendWaiverOfAppealRequestPartyReply(this.formModel).then(() => {
        this.toaster.success(this.local.caseRelatedRequest.waiverOfAppealRequest.SuccessReplyMessage);
        this.$router.push({ path: '/' });
      }).catch((err) => {
        this.toaster.console.error(err.message);
      })
        .finally(() => (this.loading = false));
    },
    changeRepresentativesEvent() {
      const approvalStatus = this.representatives.find(item => item.casePartyId === this.representativeCasePartyId).approvalStatus;
      this.$set(this.formModel, 'approvalStatus', approvalStatus);
    },
    readCurrentUserInfo() {
      if (this.userInfo) {
        const socialTypeId = this.userInfo.socialIdType;
        this.$set(this.formModel, 'socialIdType', socialTypeId);
        this.$set(this.formModel, 'socialId', this.userInfo.socialId);
        this.$set(this.formModel, 'firstName', this.userInfo.firstName);
        this.$set(this.formModel, 'fatherName', this.userInfo.fatherName);
        this.$set(this.formModel, 'grandFatherName', this.userInfo.grandFatherName);
        this.$set(this.formModel, 'familyName', this.userInfo.familyName);
        this.$set(this.formModel, 'dateOfBirth', this.userInfo.dateOfBirth);
        this.$set(this.formModel, 'nationalityCountryId', socialTypeId === socialIdentityTypeEnum.nationalId ? countriesEnum.saudiArabia : this.userInfo.nationalityCountryId);
        this.$set(this.formModel, 'sex', this.userInfo.gender);
        this.$set(this.formModel, 'isRetrievedFromMoi', true);
        this.$set(this.formModel, 'fullName', this.userInfo.fullName);
      } else {
        this.$set(this.formModel, 'socialIdType', null);
        this.$set(this.formModel, 'socialId', null);
        this.$set(this.formModel, 'firstName', null);
        this.$set(this.formModel, 'fatherName', null);
        this.$set(this.formModel, 'grandFatherName', null);
        this.$set(this.formModel, 'familyName', null);
        this.$set(this.formModel, 'dateOfBirth', null);
        this.$set(this.formModel, 'nationalityCountryId', null);
        this.$set(this.formModel, 'sex', null);
        this.$set(this.formModel, 'isRetrievedFromMoi', false);
        this.$set(this.formModel, 'fullName', null);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.judgement-deed {
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .radio-button-option-v1 {
  .v-input--radio-group {
    .radio-button-option {
      background: none;
      border-top: 0px solid #fff;
      border-bottom: 0px solid #fff;
      &:first-child {
        border-right: 0px solid #fff;
      }
      &:last-child {
        border-left: 0px solid #fff;
      }
    }
  }
}
</style>